// extracted by mini-css-extract-plugin
export var button = "button-module--button--v9K7n";
export var primary = "button-module--primary--5GZlu";
export var loading = "button-module--loading--GjsDH";
export var success = "button-module--success--mn9Uq";
export var error = "button-module--error--vJj9D";
export var secondary = "button-module--secondary--sgeLe";
export var line = "button-module--line--o1inr";
export var tertiary = "button-module--tertiary--DzIm-";
export var arrow = "button-module--arrow--edpJe";